<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Batch` : "Add Batch" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-autocomplete
              v-model.trim="form.year"
              label="Year*"
              outlined
              dense
              :items="years"
              :rules="[rules.required]"
              hide-details="auto"
          /></v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model.trim="form.batch"
              label="Batch*"
              outlined
              dense
              :items="[1, 2]"
              :rules="[rules.required]"
              hide-details="auto"
          /></v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model="form.program_id"
              :items="programs"
              :item-text="
                (item) =>
                  `${item.degree.short_name} ${
                    item.specialization ? `- ${item.specialization}` : ''
                  }`
              "
              item-value="id"
              label="Programme*"
              :readonly="edit"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            >
            </v-autocomplete
          ></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    batch: {
      type: Object,
      default: () => {},
    },
    programs: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {
        current_term: 1
      },
      years: Array.from({ length: 15 }, (v, k) => k + new Date().getFullYear()),
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.batch };
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.form.active = true;
        this.$emit("create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
